import {useState, useRef, useEffect} from "react";
// -
import ContainerListFilters from "./ContainersListFilters";
import translations from "../translations";
import useCustomTranslation from "core/customTranslation";
import FilterModel from "components/FilterModel";
import ItemsModel from "core/itemsModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import LoaderSpinner from "context/LoaderSpinner";
import RecoveryTable from "./RecoveryTable";
import axiApi from "../../../../ApiCaller";

const MiniQ2Form = ({model, items}) => {
    const {t: _TC} = useCustomTranslation(translations);

    const [itemsShown, setItemsShown] = useState([]);
    const filters = useRef(new FilterModel());

    const pagerModelRef = useRef(new PagerModel());

    useEffect(() => {
        pagerModelRef.current.handleCallApi = applyFilters;

    }, [])


    const applyFilters = async () => {
        console.log(filters.current)
        items.current.reset();

    }


    return (
        <div className="row">
            <div className="col-12">
                <ContainerListFilters
                    filters={filters}
                    applyFilters={applyFilters}
                    setItemsShown={setItemsShown}
                />
                <LoaderSpinner isLoading={false}>
                    <RecoveryTable
                        itemsShown={itemsShown}
                    />

                </LoaderSpinner>
            </div>
        </div>
    )
}
export default MiniQ2Form;